import { Resolver, Query, Arg } from 'type-graphql'
import { DataSpec, DataSpecList } from './data-spec.js'
import { DataSpecManager } from './data-spec-manager.js'

@Resolver(DataSpec)
export class DataSpecQuery {
  @Query(returns => DataSpec, { description: 'To fetch a data-spec' })
  dataSpec(@Arg('name') name: string): DataSpec {
    return DataSpecManager.getDataSpec(name)
  }

  @Query(returns => DataSpecList, { description: 'To fetch all data-specs' })
  dataSpecs(): DataSpecList {
    const items = DataSpecManager.getDataSpecs()

    return {
      items,
      total: items.length
    }
  }
}
